(() => {
  if (window.themeMediaResources) return;

  const youtubeUrl = 'https://www.youtube.com/iframe_api';
  const playerCssUrl = 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css';
  let youtubeReady;

  function loadYouTube() {
    if (window.YT && typeof window.YT.Player === 'function') return Promise.resolve();
    if (youtubeReady) return youtubeReady;

    youtubeReady = new Promise((resolve, reject) => {
      const previousReady = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        try {
          if (typeof previousReady === 'function') previousReady();
        } finally {
          resolve();
        }
      };

      let script = Array.from(document.scripts).find(element => element.src === youtubeUrl);
      const exists = Boolean(script);
      if (!script) {
        script = document.createElement('script');
        script.src = youtubeUrl;
        script.async = true;
      }
      script.addEventListener('error', () => {
        youtubeReady = undefined;
        script.remove();
        reject(new Error('YouTube player API could not be loaded'));
      }, { once: true });
      if (!exists) document.head.appendChild(script);
    });
    return youtubeReady;
  }

  function prepare(elements) {
    const types = new Set(elements.map(element => element.dataset.mediaType));
    const features = [];
    const resources = [];

    if (types.has('video')) {
      features.push({ name: 'video-ui', version: '1.0' });
      if (!Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some(link => link.href === playerCssUrl)) {
        const stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = playerCssUrl;
        document.head.appendChild(stylesheet);
      }
    }
    if (types.has('model')) {
      features.push({ name: 'model-viewer-ui', version: '1.0' }, { name: 'shopify-xr', version: '1.0' });
    }
    if (features.length) {
      resources.push(new Promise((resolve, reject) => {
        window.Shopify.loadFeatures(features, errors => {
          if (errors && errors.length) reject(new Error('Shopify media features could not be loaded'));
          else resolve();
        });
      }));
    }
    if (types.has('external_video')) resources.push(loadYouTube());

    return Promise.all(resources);
  }

  window.themeMediaResources = { prepare };
})();
